export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  window.addEventListener('load', () => {
    // A service worker must not run alongside Vue CLI's development server:
    // cached modules and HMR requests can otherwise be served as index.html.
    if (process.env.NODE_ENV !== 'production') {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister())
      })
      return
    }

    navigator.serviceWorker.register('/sw.js').catch((error) => {
      // Registration failure should not block the app.
      console.error('Service worker registration failed:', error)
    })
  })
}
